module.exports = __webpack_public_path__ + "static/media/zoom.04610544.svg";